var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapCluster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    transform: "translate(-116 -322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M0,15,20,5,40,15V40L20,50,0,40Z",
    transform: "translate(116 317)",
    fill: "#5758a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M0,14,18,5l18,9L18,23Z",
    transform: "translate(118 342)",
    fill: "#00ffec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CTC_-_Logo_Purple_kopie",
    "data-name": "CTC - Logo Purple kopie",
    transform: "translate(-396 324.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    width: 20,
    height: 20,
    transform: "translate(522 2.2)",
    fill: "#5758a6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapCluster);
export default __webpack_public_path__ + "static/media/map-cluster.8d73f4cce741f59a638c790ee6d5ce09.svg";
export { ForwardRef as ReactComponent };